import { RoleEnum } from "common/types/graphql"

export type CurrentUserDonations = {
  lastDonated: string
  lastDonationRecurring: boolean
  lastRegionDonatedTo: string
  numDonations: number
  numDonationsThisYear: number
  totalAmount: number
  totalAmountThisYear: number
}

export type CurrentUserNewsletterList = {
  id: number
  name: string
  pitch: string
  frequency: string
  region_code: string
}

type CurrentUserEmail = {
  email: string
  primary: boolean
  newsletter_lists: CurrentUserNewsletterList[]
}

/** @internal Knip: exported for tests */
export type SignedInUser = {
  id: number
  type: RoleEnum
  full_name: string
  avatar_url: string
  allow: { analytics: boolean; moderate_comments: boolean; video_with_metadata: boolean }
  donations: CurrentUserDonations
  news_feed_count?: number
  comment_notification_count?: number
  emails?: CurrentUserEmail[]
}

// Rails answers `{}` when nobody is signed in.
export type CurrentUser = SignedInUser | { id?: undefined }

/**
 * Fetches `/users/current.json` from Rails, which the router serves on the same origin.
 */
export const fetchCurrentUser = async (url: string): Promise<CurrentUser> => {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`An error occurred while fetching the current user: (${response.status})`)
  }

  return response.json()
}
